<template>
  <div id="main-content" class="detail-sub-driver">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">{{ $t('common.edit') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form>
        <el-row>
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.bus_stop') }}:</span>
            <span class="info-span"> {{ placeInfo.name }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.address') }}:</span>
            <span class="info-span"> {{ placeInfo.address }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.school') }}:</span>
            <span class="info-span" v-if="placeInfo.is_school">{{ $t('common.yes') }}</span>
            <span class="info-span" v-else>{{ $t('common.no') }}</span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.parking_lot') }}:</span>
            <span class="info-span" v-if="placeInfo.is_parking">{{ $t('common.yes') }}</span>
            <span class="info-span" v-else>{{ $t('common.no') }}</span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('bus_stop.pickup_time') }}:</span>
            <span class="info-span"> {{ placeInfo.pickup_time }} </span>
          </el-col>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "DetailPlace",
    components: {
      PageTitle
    },
    data: function () {
      return {
        title: 'bus_stop.bus_stop_information',
        backLink: `/place?action=back`
      }
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        place_id: this.$route.query.pid
      }
      this.$store.dispatch('place/getPlaceInfo', payload)
    },
    computed: {
      ...mapState('place', ['placeInfo']),
    },
    methods: {
      goToEdit: function () {
        this.$router.push({path: '/place/edit', query: {pid: this.$route.query.pid}});
      }
    }
  }
</script>

<style lang="scss">
</style>